import { api } from "@/services";
import Router from "next/router";

type ForgotPasswordRequest = {
  email: string;
  created: false;
  referer: string;
  site: "NOVOSITE" | "MICHELIN" | "LingLong" | "LINGLONG" | "BFGOODRICH";
};

type ForgotPasswordResponse = {
  status: boolean;
  msgs: string[] | string;
};

async function useForgotPassword({
  email,
  created,
  site,
  referer
}: ForgotPasswordRequest): Promise<
  [Response: ForgotPasswordResponse | null, Error: string[] | null, Loading: boolean]
> {
  let Response = null;
  let Error = null;
  let Loading = true;

  const Controller = new AbortController();

  const MakeRequest = async (): Promise<void> => {
    try {
      const resp: { data: ForgotPasswordResponse } = await api.post(`/Auth/ForgotPassword`, null, {
        signal: Controller.signal,
        params: {
          email: email,
          created: created,
          referer: null,
          site: site
        }
      });
      if (resp.data.status) {
        Response = resp.data;
      } else {
        Error = [
          "Erro ao tentar enviar o email de recuperação de senha. Tente novamente mais tarde.",
          resp.data.msgs
        ];
      }
    } catch (error) {
      Error = [
        "Erro ao tentar enviar o email de recuperação de senha. Tente novamente mais tarde.",
        error.message
      ];
    } finally {
      Loading = false;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, Error, Loading];
}

export { useForgotPassword };
